import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  list: [],
  user: null,
  error: "",
  loading: false,
  hierarchyList: [],
  hierarchyLoading: false,
  hierarchyError: "",
};

export const addIndivisualUser = createAsyncThunk(
  "user/addIndivisualUser",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        // url: `user/register`,
        url: `user/indivisualRegister`,
        data: {
          ...values,
        },
      });
      toast.success("Registration successful");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding user try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "user/forgotPassword",
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        method: "post", // Changed to POST
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/PasswordReset`,
        data: {
          EmailId: values.email, // Map the email field to EmailId
        },
      });

      toast.success(data.message); // Show success message from API
      return {
        data,
        message: "success",
      };
    } catch (error) {
      // Handle different types of errors
      if (error.response) {
        const errorMessage =
          error.response.data.message || "Error resetting password";
        toast.error(errorMessage);
        return rejectWithValue(errorMessage);
      } else if (error.request) {
        toast.error("Network error. Please check your connection");
        return rejectWithValue("Network error");
      } else {
        toast.error("Error resetting password. Please try again");
        return rejectWithValue("Error resetting password");
      }
    }
  }
);

export const changePasswordToAdmin = createAsyncThunk(
  "user/changePasswordToAdmin",
  async (EmployeeId, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `employee/EmployeesPasswordReset?EmployeeId=${EmployeeId}`,
      });

      return {
        data,
        message: "success",
      };
    } catch (error) {
      // Handle different types of errors
      if (error.response) {
        // Server responded with error
        const errorMessage =
          error.response.data.message || "Error resetting password";
        toast.error(errorMessage);
        return rejectWithValue(errorMessage);
      } else if (error.request) {
        // Request made but no response
        toast.error("Network error. Please check your connection");
        return rejectWithValue("Network error");
      } else {
        // Something else went wrong
        toast.error("Error resetting password. Please try again");
        return rejectWithValue("Error resetting password");
      }
    }
  }
);

export const postBankDetails = createAsyncThunk(
  "user/postBankDetails",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        // url: `user/register`,
        url: `user/BankDetails`,
        data: {
          ...values,
        },
      });
      toast.success("Bank Details add successful");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding bank details try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/change-password`,
        data: {
          ...values,
        },
      });
      toast.success("Change Password successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in Change Password try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

// export const addStaff = createAsyncThunk("user/addStaff", async (values) => {
// 	try {
// 	// console.log("slice values", values)
// 		const { data } = await axios({
// 			method: "post",
// 			headers: {
// 				Accept: "application/json",

// 				"Content-Type": "multipart/form-data",
// 			},
// 			url: `user/register`,
// 			// url: `user/indivisualRegister`,
// 			data: {
// 				...values,
// 			},
// 		});
// 		toast.success("Registration successful");
// 		return {
// 			data,
// 			message: "success",
// 		};
// 	} catch (error) {
// 		toast.error("Error in adding staff try again");
// 		// console.log(error.message);
// 		return {
// 			message: "error",
// 		};
// 	}
// });

export const addStaff = createAsyncThunk("user/addStaff", async (values, { rejectWithValue }) => {
  try {
    // console.log("slice values", values);

    // // Create a FormData object
    // const formData = new FormData();

    // // Append all fields from values to FormData
    // Object.keys(values).forEach((key) => {
    //     if (key === "file" && values[key]) {
    //         // Append the file separately
    //         formData.append("file", values[key]);
    //     } else if (typeof values[key] === "object" && values[key] !== null) {
    //         // Stringify nested objects (e.g., educations, salaryComponents)
    //         formData.append(key, JSON.stringify(values[key]));
    //     } else {
    //         // Append primitive values directly
    //         formData.append(key, values[key]);
    //     }
    // });

    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8", // This is optional; Axios sets it automatically with FormData
      },
      url: `employee/EmployeeDetailsSetup`,
      data: values, // Send FormData instead of a plain object
    });

    toast.success("Registration successful");
    return {
      data,
      message: "success",
    };
  } catch (error) {
    // Handle different types of errors
    if (error.response) {
      const statusCode = error.response.status;
      const responseData = error.response.data;
      
      // Handle specific status codes
      if (statusCode === 409) {
        // Check if response is an array of error objects
        if (Array.isArray(responseData)) {
          const errorMessages = responseData
            .filter(item => item.status === "error")
            .map(item => item.message);
          
          // Display each error message separately
          errorMessages.forEach(msg => toast.error(msg));
          
          const combinedMessage = errorMessages.join(". ");
          return rejectWithValue({ message: combinedMessage, statusCode, errors: responseData });
        } else {
          const errorMessage = responseData?.message || "Conflict: Data already exists";
          toast.error(errorMessage);
          return rejectWithValue({ message: errorMessage, statusCode });
        }
      } else if (statusCode === 400) {
        const errorMessage = responseData?.message || "Bad request. Please check your input data.";
        toast.error(errorMessage);
        return rejectWithValue({ message: errorMessage, statusCode });
      } else if (statusCode === 500) {
        toast.error("Server error. Please try again later.");
        return rejectWithValue({ message: "Server error", statusCode });
      } else {
        const errorMessage = responseData?.message || "Error adding staff";
        toast.error(errorMessage);
        return rejectWithValue({ message: errorMessage, statusCode });
      }
    } else if (error.request) {
      toast.error("Network error. Please check your connection");
      return rejectWithValue({ message: "Network error" });
    } else {
      toast.error("Error in adding staff, try again");
      return rejectWithValue({ message: "Unknown error" });
    }
  }
});

export const uploadUsersFromExcel = createAsyncThunk(
  "user/uploadUsersFromExcel",
  async (fileData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "employee/EmployeeUploads",
        fileData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob", // Important for downloading CSV
        }
      );

      // Convert the response to a Blob
      const blob = new Blob([res.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      // Create a download link
      const a = document.createElement("a");
      a.href = url;
      a.download = "EmployeesImportStatus.csv"; // Suggested filename
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      return true; // Or return some status if needed
    } catch (error) {
      toast.error("Error uploading users");
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const deleteStaff = createAsyncThunk("user/deleteStaff", async (id) => {
  try {
    const resp = await axios({
      method: "patch",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `user/${id}`,
      data: {
        status: false,
      },
    });
    return resp.data;
  } catch (error) {
    // console.log(error.message);
  }
});

export const getBankDetailsByUserId = createAsyncThunk(
  "user/getBankDetailsByUserId",
  async (userId) => {
    try {
      const data = await axios.get(`user/bankDetails/${userId}`);
      return data;
    } catch (error) {
      // console.log(error.message);
    }
  }
);

export const loadSingleStaff = createAsyncThunk(
  "user/loadSingleStaff",
  async (id) => {
    try {
      const response = await axios.get(`employee/GetEmployeesById`, {
        params: { EmployeeId: id },
      });
      return response.data;
    } catch (error) {
      // console.log(error.message);
      throw error;
    }
  }
);

export const getCompanyNameByClientId = createAsyncThunk(
  "user/getCompanyNameByClientId",

  async (id) => {
    // console.log("done");

    try {
      const data = await axios.get(`user/getCompanyNameByClientId/${id}`);
      return data;
    } catch (error) {
      // console.log(error.message);
    }
  }
);

export const loadAllStaff = createAsyncThunk("user/loadAllStaff", async () => {
  try {
    const { data } = await axios.get(`employee/GetEmployeesList`);
    // console.log("Loaded Staff Data:", data);
    return data;
  } catch (error) {
    // console.log(error.message);
  }
});

export const getEmployeeHierarchy = createAsyncThunk(
  "user/getEmployeeHierarchy",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`employee/GetEmployeeHierarchy`);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Failed to load hierarchy";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const loadTodaysBirthdays = createAsyncThunk(
  "users/loadTodaysBirthdays",
  async () => {
    const response = await axios.get("user/birthdays");
    // console.log("API Response>>>>>:", response.data);
    return response.data;
  }
);

export const loadUpcomingBirthdays = createAsyncThunk(
  "users/loadUpcomingBirthdays",
  async () => {
    const response = await axios.get("user/getUpcomingBirthdays");
    // console.log("API Response<<<<<:", response.data);
    return response.data;
  }
);

export const getUserDevices = createAsyncThunk(
  "user/getUserDevices",
  async () => {
    const response = await axios.get("employee/GetEmployeesByMobileAccess");
    // console.log("API Response>>>>>:", response.data);
    return response.data;
  }
);

export const getCompanyOfficeMaster = createAsyncThunk(
  "user/getCompanyOfficeMaster",
  async () => {
    const response = await axios.get("user/getCompanyOfficeMaster");
    // console.log("API Response>>>>>:", response.data);
    return response.data;
  }
);

export const addUser = createAsyncThunk("user/addUser", async (values, { rejectWithValue }) => {
  try {
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `user/login`,
      data: {
        ...values,
      },
    });
    localStorage.setItem("access-token", data.AccessToken);
    // localStorage.setItem("role", data.role);
    // localStorage.setItem("roleId", data.RoleId);
    localStorage.setItem("user", data.UserName);
    // localStorage.setItem("id", data.UserId);
    localStorage.setItem("isLogged", true);
    // localStorage.setItem("company_id", data.CompanyId);
    localStorage.setItem("RequirePasswordChange", data.RequirePasswordChange);
    // toast.success(" Login Successfully Done");
    // console.log("hh", data);

    return {
      data,
      message: "success",
    };
  } catch (error) {
    // console.log("Login error:", error);
    // Show the actual error message from API
    if (error.response && error.response.data && error.response.data.message) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data.message);
    } else {
      toast.error("Incorrect UserName or Password !");
      return rejectWithValue("Incorrect UserName or Password !");
    }
  }
});

// Update User Information

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (values) => {
    // console.log("updateUser called with values:", values);

    try {
      const { data } = await axios({
        method: "post",
        url: `employee/EmployeePersonalInformationUpdate`,
        data: {
          ...values,
        },
      });
      // console.log("API Response:", data);
      toast.success("User Information Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      // console.log("API Error:", error.message);
      toast.error("Error in updating user information");
      return {
        message: "error",
      };
    }
  }
);



export const EmployeeContactInformationUpdate = createAsyncThunk(
  "user/EmployeeContactInformationUpdate",
  async (values) => {
    // console.log("valuesupdate personal", values);

    try {
      const { data } = await axios({
        method: "post",
        url: `employee/EmployeeContactInformationUpdate`,
        data: {
          ...values,
        },
      });
      toast.success("User Information Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      // console.log(error.message);
      toast.error("Error in updating user information");
      return {
        message: "error",
      };
    }
  }
);

export const EmployeeAddressInformationUpdate = createAsyncThunk(
  "user/EmployeeAddressInformationUpdate",
  async (values) => {
    // console.log("valuesupdate personal", values);

    try {
      const { data } = await axios({
        method: "post",
        url: `employee/EmployeeAddressInformationUpdate`,
        data: {
          ...values,
        },
      });
      toast.success("Address Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      // console.log(error.message);
      toast.error("Error in updating user information");
      return {
        message: "error",
      };
    }
  }
);

export const updateBankDetails = createAsyncThunk(
  "user/updateBankDetails",
  async ({ id, values }) => {
    try {
      const { data } = await axios({
        method: "put",
        url: `user/bankDetails/${id}`,
        data: {
          ...values,
        },
      });
      toast.success("Bank Details Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      // console.log(error.message);
      toast.error("Error in updating Bank Details");
      return {
        message: "error",
      };
    }
  }
);

// Add this to your userSlice
// export const removeBiometric = createAsyncThunk(
// 	"user/removeBiometric",
// 	async (EmployeeId) => {
// 	  try {
// 		const response = await axios.get(`user/MobileIdDeRegiester?EmployeeId=${EmployeeId}`);
// 		toast.success("Biometric data removed successfully");
// 		return EmployeeId; // Return the ID of the removed biometric
// 	  } catch (error) {
// 		toast.error("Error removing biometric data");
// 		// console.log(error.message);
// 		return Promise.reject(error.message);
// 	  }
// 	}
//   );

export const removeBiometric = createAsyncThunk(
  "user/removeBiometric",
  async (EmployeeId) => {
    try {
      const response = await axios.get(
        `user/MobileIdDeRegiester?EmployeeId=${EmployeeId}`
      );
      return response;
    } catch (error) {
      toast.error("Error removing biometric data");
    }
  }
);

export const EmployeeReportingHistorySetup = createAsyncThunk(
  "shift/EmployeeReportingHistorySetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `employee/EmployeeReportingHistorySetup`,
        data: {
          ...values,
        },
      });
      toast.success("Employment Status Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding Employment Status try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const EmployeeOfficeInformationUpdate = createAsyncThunk(
  "user/EmployeeOfficeInformationUpdate",
  async ({ values }, { rejectWithValue }) => {
    // console.log("Payload sent to API:", values); // Log the payload
    try {
      const { data } = await axios({
        method: "post",
        url: `employee/EmployeeOfficeInformationUpdate`,
        data: values, // Simplified to send values directly
      });
      toast.success("User Information Updated Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      // console.log("API error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const EmployeeBankDetailsSetup = createAsyncThunk(
  "setting/EmployeeBankDetailsSetup",
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `employee/EmployeeBankDetailsSetup`,
        data: {
          ...values,
        },
      });
      toast.success("Bank Details Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      // console.log("API error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUser: (state) => {
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    // 1) ====== builders for loadAllStaff ======

    builder.addCase(loadAllStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadAllStaff.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload || [];
    });

    builder.addCase(loadAllStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.message;
    });

    // ====== builders for getEmployeeHierarchy ======
    builder.addCase(getEmployeeHierarchy.pending, (state) => {
      state.hierarchyLoading = true;
      state.hierarchyError = "";
    });
    builder.addCase(getEmployeeHierarchy.fulfilled, (state, action) => {
      state.hierarchyLoading = false;
      state.hierarchyList = action.payload || [];
      state.hierarchyError = "";
    });
    builder.addCase(getEmployeeHierarchy.rejected, (state, action) => {
      state.hierarchyLoading = false;
      state.hierarchyList = [];
      state.hierarchyError = action.payload || "Failed to load hierarchy";
    });

    // 2) ====== builders for EmployeeReportingHistorySetup ======

    builder.addCase(EmployeeReportingHistorySetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      EmployeeReportingHistorySetup.fulfilled,
      (state, action) => {
        state.loading = false;

        if (!Array.isArray(state.list)) {
          state.list = [];
        }
        const list = [...state.list];
        list.push(action.payload);
        state.list = list;
      }
    );

    builder.addCase(EmployeeReportingHistorySetup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 1) ====== builders for getCompanyOfficeMaster ======

    builder.addCase(getCompanyOfficeMaster.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getCompanyOfficeMaster.fulfilled, (state, action) => {
      state.loading = false;
      state.officeName = action.payload;
    });

    builder.addCase(getCompanyOfficeMaster.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2) ====== builders for addStaff ======

    builder.addCase(addStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addStaff.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "Error adding staff";
    });

    // 2) ====== builders for uploadUsersFromExcel ======

    builder.addCase(uploadUsersFromExcel.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(uploadUsersFromExcel.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(uploadUsersFromExcel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2.1) ====== builders for addIndivisualUser ======

    builder.addCase(addIndivisualUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addIndivisualUser.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addIndivisualUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2.1) ====== builders for changePasswordToAdmin ======

    builder.addCase(changePasswordToAdmin.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(changePasswordToAdmin.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(changePasswordToAdmin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

     // 2.1) ====== builders for forgotPassword ======

    builder.addCase(forgotPassword.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(forgotPassword.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(forgotPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });


    // 2.1) ====== builders for postBankDetails ======

    builder.addCase(postBankDetails.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(postBankDetails.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(postBankDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2.2) ====== builders for changePassword ======

    builder.addCase(changePassword.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(changePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 3) ====== builders for addUser ======

    builder.addCase(addUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addUser.fulfilled, (state, action) => {
      state.loading = false;

      if (!Array.isArray(state.user)) {
        state.user = [];
      }
      const user = [...state.user];
      user.push(action.payload.data);
      state.user = user;
    });

    builder.addCase(addUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for updateUser ======

    builder.addCase(updateUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.loading = false;
      
      // Update the local state if we have the updated user data
      if (action.payload?.data && state.list) {
        const updatedUser = action.payload.data;
        const userIndex = state.list.findIndex(
          (user) => user.EmployeeId === updatedUser.EmployeeId
        );
        
        if (userIndex !== -1) {
          // Update the specific user in the list
          state.list[userIndex] = { ...state.list[userIndex], ...updatedUser };
        }
      } else if (action.payload?.message === "success" && action.meta?.arg) {
        // If we don't have the updated user data but the update was successful,
        // manually update the status in the local state
        const { EmployeeId, DataStatus } = action.meta.arg;
        const userIndex = state.list.findIndex(
          (user) => user.EmployeeId === EmployeeId
        );
        
        if (userIndex !== -1) {
          // Update the specific user's status in the list
          state.list[userIndex] = { 
            ...state.list[userIndex], 
            DataStatus: DataStatus,
            dataStatus: DataStatus // Also update the lowercase version if it exists
          };
          
          // console.log(`Updated user ${EmployeeId} status to ${DataStatus} in Redux state`);
        }
      }
    });

    builder.addCase(updateUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });



    // 4) ====== builders for EmployeeOfficeInformationUpdate ======

    builder.addCase(EmployeeOfficeInformationUpdate.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      EmployeeOfficeInformationUpdate.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    );

    builder.addCase(
      EmployeeOfficeInformationUpdate.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      }
    );

    // 4) ====== builders for EmployeeContactInformationUpdate ======

    builder.addCase(EmployeeContactInformationUpdate.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      EmployeeContactInformationUpdate.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    );

    builder.addCase(
      EmployeeContactInformationUpdate.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      }
    );

    // 4) ====== builders for EmployeeAddressInformationUpdate ======

    builder.addCase(EmployeeAddressInformationUpdate.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      EmployeeAddressInformationUpdate.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    );

    builder.addCase(
      EmployeeAddressInformationUpdate.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      }
    );

    // 4) ====== builders for loadSingleStaff ======

    builder.addCase(loadSingleStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadSingleStaff.fulfilled, (state, action) => {
      state.loading = false;

      state.user = action.payload;
    });

    builder.addCase(loadSingleStaff.rejected, (state, action) => {
      state.loading = false;
      // console.log(action.payload);
      state.error = action.payload.message;
    });

    // 4) ====== builders for getBankDetailsByUserId ======

    builder.addCase(getBankDetailsByUserId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getBankDetailsByUserId.fulfilled, (state, action) => {
      state.loading = false;

      state.user = action.payload.data;
    });

    builder.addCase(getBankDetailsByUserId.rejected, (state, action) => {
      state.loading = false;
      // console.log(action.payload);
      state.error = action.payload.message;
    });

    // 4) ====== builders for getCompanyNameByClientId ======

    builder.addCase(getCompanyNameByClientId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getCompanyNameByClientId.fulfilled, (state, action) => {
      state.loading = false;

			state.companyName = action.payload.data ||[];
		});

    builder.addCase(getCompanyNameByClientId.rejected, (state, action) => {
      state.loading = false;
      // console.log(action.payload);
      state.error = action.payload.message;
    });

    // 5) ====== builders for loadTodaysBirthdays ======

    builder.addCase(loadTodaysBirthdays.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadTodaysBirthdays.fulfilled, (state, action) => {
      const bday = action.payload;
      // console.log("todaybirthday", bday);
      state.loading = false;
      state.todaysBirthdays = action.payload;
    });

    builder.addCase(loadTodaysBirthdays.rejected, (state, action) => {
      state.loading = false;
      // console.log(action.payload);
      state.error = action.payload.message;
    });

    // 6) ====== builders for loadUpcomingBirthdays ======

    builder.addCase(loadUpcomingBirthdays.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadUpcomingBirthdays.fulfilled, (state, action) => {
      const upcomingbday = action.payload;
      // console.log("upcomingbday", upcomingbday);
      state.loading = false;
      state.upcomingBirthdays = action.payload;
    });

    builder.addCase(loadUpcomingBirthdays.rejected, (state, action) => {
      state.loading = false;
      // console.log(action.payload);
      state.error = action.payload.message;
    });

    // 6) ====== builders for getUserDevices ======

    builder.addCase(getUserDevices.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getUserDevices.fulfilled, (state, action) => {
      state.loading = false;
      state.userDeviceDetails = action.payload ||[];
      state.total = action.payload.length; // Adjust this if necessary
    });

    builder.addCase(getUserDevices.rejected, (state, action) => {
      state.loading = false;
      // console.log(action.payload);
      state.error = action.payload.message;
    });

    // 7) ====== builders for deleteStaff ======

    builder.addCase(deleteStaff.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(deleteStaff.fulfilled, (state, action) => {
      state.loading = false;

      const filterUser = state.list.filter(
        (staff) => staff.id !== parseInt(action.payload) && staff
      );

      state.list = filterUser;
    });

    builder.addCase(deleteStaff.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 8) ====== builders for removeBiometric ======

    // Add this to the extraReducers in your userSlice
    builder.addCase(removeBiometric.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(removeBiometric.fulfilled, (state, action) => {
      state.loading = false;
      state.userDeviceDetails = state.userDeviceDetails.filter(
        (device) => device.userDeviceId !== action.payload
      );
    });

    builder.addCase(removeBiometric.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 2) ====== builders for EmployeeBankDetailsSetup ======

    builder.addCase(EmployeeBankDetailsSetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(EmployeeBankDetailsSetup.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(EmployeeBankDetailsSetup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

export default userSlice.reducer;
export const { clearUser } = userSlice.actions;
